import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { postMethod } from "../../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faSpinner } from "@fortawesome/free-solid-svg-icons";
import Search from "../../../components/inputs/Search";
import { BasicContext } from "../../../App";
import LoadedRecords from "../../../components/LoadedRecords";
import PassesPurchaseStatusDropdown from "../../../components/dropdowns/PassesPurchaseStatusDropdown";
import UserPass from "../../../components/passes/UserPass";
import PassesStatusDropdown from "../../../components/dropdowns/PassesStatusDropdown";

const StudentsPasses = () => {
    const { t } = useTranslation();
    const { checkServerData, NOR } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [originalList, setOriginalList] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedPassPurchase, setSelectedPassPurchase] = useState("default");
    const [selectedPassStatus, setSelectedPassStatus] = useState("PURCHASED");
    const [search, setSearch] = useState("");
    const [displayNOR, setDisplayNOR] = useState(NOR);

    const applyFilter = (_list) => {
        let filteredList = [..._list];
        filteredList = filteredList.filter(
            (e) => (selectedPassPurchase === "default" || e.purchaseStatus === selectedPassPurchase) && (selectedPassStatus === "default" || e.up_status_code === selectedPassStatus)
        );
        setList(filteredList);
    };

    const getStudentsPasses = async () => {
        const res = await postMethod("/get-students-passes");
        if (checkServerData(res)) {
            setOriginalList(res.data.list);
            applyFilter(res.data.list);
        }
    };

    const handleSearch = (v) => {
        const searchedPhrase = v.toLowerCase();
        setSearch(searchedPhrase);
        if (searchedPhrase !== "") {
            let filterThisList = originalList;
            filterThisList = filterThisList.filter(
                (el) =>
                    el.pass_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.buying_user_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.order_number.toString().toLowerCase().includes(searchedPhrase)
            );
            setList(filterThisList);
        } else {
            setList(originalList);
        }
    };

    const reload = () => {
        setLoading(true);
        setTimeout(() => {
            getStudentsPasses();
        }, 200);
    };

    useEffect(() => {
        if (list) {
            if (loading) setLoading(false);
        }
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        if (list) applyFilter(originalList);
        // eslint-disable-next-line
    }, [selectedPassPurchase, selectedPassStatus]);

    useEffect(() => {
        getStudentsPasses();

        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            {loading ? (
                <Container>
                    <Row>
                        <Col className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Fragment>
                    <Container fluid="lg">
                        <Row>
                            <Col xs={12} className="px-4 mt-4 mb-3 px-lg-2 ">
                                <h1 className="h4 d-inline-block m-0 pt-2">{t("passes.studentsPasses")}</h1>
                                <Button
                                    className="float-end d-inline-block me-2"
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setLoading(true);
                                        getStudentsPasses();
                                    }}
                                >
                                    <FontAwesomeIcon icon={faArrowsRotate} />
                                </Button>
                            </Col>
                        </Row>
                        <Row className="sticky-top bg-light-primary">
                            <Col xs={12} lg={6} className="px-4 mt-lg-4 px-lg-2">
                                <PassesPurchaseStatusDropdown onChange={(v) => setSelectedPassPurchase(v)} value={selectedPassPurchase} />
                            </Col>
                            <Col xs={12} lg={6} className="px-4 mt-lg-4 px-lg-2">
                                <PassesStatusDropdown onChange={(v) => setSelectedPassStatus(v)} value={selectedPassStatus} />
                            </Col>
                            <Col xs={12} lg={6} className="px-4 mb-lg-4 px-lg-2">
                                <Search value={search} onChange={(e) => handleSearch(e.target.value)} />
                            </Col>
                        </Row>
                        <Row>
                            {list && (
                                <Fragment>
                                    {list.length > 0 ? (
                                        <Fragment>
                                            <LoadedRecords displayNOR={displayNOR} list={list} />
                                            <Col xs={12} className="px-0 px-lg-2 ">
                                                <Table className="white-table">
                                                    <tbody>
                                                        {list
                                                            .map((e, i) => (
                                                                <Fragment key={i}>
                                                                    <UserPass pass={e} reload={reload} adminView reloadData={reload} showUserName />
                                                                </Fragment>
                                                            ))
                                                            .slice(0, displayNOR)}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                            <LoadedRecords displayNOR={displayNOR} list={list} />
                                            <Col xs={12} className="text-center">
                                                {displayNOR >= list.length ? (
                                                    <p className="opacity-4  mb-3">
                                                        <span className="px-3">{t("thatsAll")}</span>
                                                    </p>
                                                ) : (
                                                    <Button onClick={() => setDisplayNOR(NOR + displayNOR)} variant="outline-primary" className="mb-3">
                                                        {t("loadMore")}
                                                    </Button>
                                                )}
                                            </Col>
                                        </Fragment>
                                    ) : (
                                        <Col xs={12} className="text-center">
                                            <p className="fs-5">{t("notFound")}</p>
                                        </Col>
                                    )}
                                </Fragment>
                            )}
                        </Row>
                    </Container>
                </Fragment>
            )}
        </Fragment>
    );
};

export default StudentsPasses;
